import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useEffect } from "react";

gsap.registerPlugin(ScrollTrigger);

const parallax = (scrollTriggerConfig, doms, unit) => {
  let tl = gsap.timeline({
    scrollTrigger: scrollTriggerConfig,
  });

  if (doms.length) {
    [...doms].forEach((dom) => {
      tl.to(
        dom,
        {
          y: (i, el) => {
            // console.log(gsap.getProperty(el, "--smq4-offset-end"), unit);
            return gsap.getProperty(el, "--smq4-offset-end", unit);
          },
        },
        0
      );
    });
  } else {
    tl.to(doms, {
      y: (i, el) => {
        // console.log(gsap.getProperty(el, "--smq4-offset-end", unit));
        return gsap.getProperty(el, "--smq4-offset-end", unit);
      },
    });
  }
};

export default parallax;
